export default "__VITE_ASSET__1b9058ce__"